export const FREE_BETS_REQUEST = 'freeBets/REQUEST';
export const FREE_BETS_SUCCESS = 'freeBets/REQUEST_SUCCESS';
export const FREE_BETS_FAILURE = 'freeBets/REQUEST_FAILURE';

export const freeBetsRequest = () => ({
  type: FREE_BETS_REQUEST
});

export const freeBetsSuccess = (vouchers) => ({
  type: FREE_BETS_SUCCESS,
  vouchers
});

export const freeBetsFailure = () => ({
  type: FREE_BETS_FAILURE
});
